/**
 * procConfigs.js — Unified config for ALL procurement transaction form screens
 *
 * One place to define every screen's:
 *   - title, crumb, tabs, doc labels
 *   - General tab header fields (gFields)
 *   - Secondary tab header fields (poFields)
 *
 * Used by ProcurementForm.jsx (single shared form component)
 */

// ─── Shared field helpers ──────────────────────────────────────────────────
const SUPPLIER_F = { id:'supplier', label:'Supplier', type:'lkp', si:{screenId:'3.2',controlId:'5'}, lt:'Select Supplier' };
const PURCH_AC_F = { id:'purchAc',  label:'Purchase A/C', type:'lkp', si:{screenId:'4.8.1',controlId:'3'}, lt:'Purchase Account' };
const PAY_MODE_F = { id:'payMode',  label:'Pay Mode', type:'sel', opts:['Credit','Cash','NEFT','RTGS','UPI'] };
const REMARKS_F  = { id:'remarks',  label:'Remarks',  type:'text' };

export const ALL_PROC_CONFIGS = {

  // ══════════════════════════════════════════════════════════════════════
  // PURCHASE INVOICE (4.10.x)
  // ══════════════════════════════════════════════════════════════════════

  '4.10.3': {
    sid:'4.10.3', isReturn:false, category:'purchase-invoice',
    title:'Purchase Invoice',
    crumb:'Procurement › Purchase Accounts › Purchase Invoice',
    tab1:'Against GRN', t1k:'F3', tab2:'Against P.I', t2k:'F4',
    docLabel:'Invoice No', prevValue:'PI101N0004',
    listCols:[
      {field:'invNo',    label:'PI NO'},     {field:'refNo',    label:'REF NO'},
      {field:'invDate',  label:'INV DATE'},  {field:'transDate',label:'TRANS DATE'},
      {field:'supplier', label:'SUPPLIER NAME'}, {field:'city', label:'CITY'},
      {field:'qty',      label:'QTY'},
    ],
    gFields:[
      {id:'invDate',   label:'Invoice Date',    type:'date'},
      {id:'invRef',    label:'Invoice Ref',      type:'text'},
      {id:'againstRef',label:'Against GRN No',   type:'lkp', si:{screenId:'4.8.1',controlId:'7'}, lt:'Select GRN'},
      {id:'grnDate',   label:'GRN Date',         type:'date'},
      PAY_MODE_F, SUPPLIER_F, PURCH_AC_F, REMARKS_F,
      {id:'invInfo',   label:'Invoice Information', type:'text'},
    ],
    poFields:[
      {id:'piDate',    label:'P.I Date',         type:'date'},
      {id:'lrRef',     label:'L.R Ref',           type:'text'},
      {id:'againstRef',label:'Against P.I No',    type:'lkp', si:{screenId:'4.10.1',controlId:'1'}, lt:'Select P.I'},
      {id:'invDate',   label:'Invoice Date',      type:'date'},
      PAY_MODE_F, SUPPLIER_F, PURCH_AC_F, REMARKS_F,
      {id:'invInfo',   label:'Invoice Information',type:'text'},
    ],
  },

  '4.10.1': {
    sid:'4.10.1', isReturn:false, category:'purchase-invoice',
    title:'Purchase Invoice Agst GRC',
    crumb:'Procurement › Purchase Accounts › Purchase Invoice Against GRC',
    tab1:'Against GRC', t1k:'F3', tab2:'Against P.I', t2k:'F4',
    docLabel:'Invoice No', prevValue:'PI101N0003',
    listCols:[{field:'invNo',label:'PI NO'},{field:'invDate',label:'DATE'},{field:'supplier',label:'SUPPLIER'},{field:'grnRef',label:'AGAINST GRN'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'invDate',label:'Invoice Date',type:'date'},{id:'invRef',label:'Invoice Ref',type:'text'},
      {id:'againstRef',label:'Against GRN No',type:'lkp',si:{screenId:'4.8.1',controlId:'7'},lt:'Select GRN'},
      {id:'grnDate',label:'GRN Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
    poFields:[
      {id:'piDate',label:'P.I Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},
      {id:'againstRef',label:'Against P.I No',type:'lkp',si:{screenId:'4.10.3',controlId:'1'},lt:'Select P.I'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  '4.10.2': {
    sid:'4.10.2', isReturn:false, category:'purchase-invoice',
    title:'Purchase Invoice Agst PO',
    crumb:'Procurement › Purchase Accounts › Purchase Invoice Against PO',
    tab1:'Against P.O', t1k:'F3', tab2:'Against P.I', t2k:'F4',
    docLabel:'Invoice No', prevValue:'PI101N0002',
    listCols:[{field:'invNo',label:'PI NO'},{field:'invDate',label:'DATE'},{field:'supplier',label:'SUPPLIER'},{field:'poRef',label:'AGAINST P.O'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'poDate',label:'P.O Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},
      {id:'againstRef',label:'Against P.O No',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
    poFields:[
      {id:'piDate',label:'P.I Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},
      {id:'againstRef',label:'Against P.I No',type:'lkp',si:{screenId:'4.10.3',controlId:'1'},lt:'Select P.I'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  '4.10.4': {
    sid:'4.10.4', isReturn:true, category:'purchase-returns',
    title:'Purchase Returns',
    crumb:'Procurement › Purchase Returns & Debit Notes › Purchase Returns',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'Return No', prevValue:'PR101N0004',
    listCols:[{field:'retNo',label:'RETURN NO'},{field:'retDate',label:'DATE'},{field:'supplier',label:'SUPPLIER'},{field:'againstRef',label:'AGAINST INVOICE'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'retDate',label:'Return Date',type:'date'},{id:'retRef',label:'Return Ref',type:'text'},
      {id:'againstRef',label:'Against Invoice No',type:'lkp',si:{screenId:'4.10.3',controlId:'1'},lt:'Select Invoice'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,
      {id:'reason',label:'Reason For Return',type:'text'},REMARKS_F,
    ],
    poFields:[
      {id:'apoDate',label:'A.P.O Date',type:'date'},{id:'mrRef',label:'M.R/L.R Ref',type:'text'},
      {id:'poRef',label:'P.O',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  '4.8.17': {
    sid:'4.8.17', isReturn:true, category:'purchase-returns',
    title:'Purchase Invoice Return',
    crumb:'Procurement › Purchase Returns › Purchase Invoice Return (New UI)',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'Return No', prevValue:'PR101N0003',
    listCols:[{field:'retNo',label:'RETURN NO'},{field:'retDate',label:'DATE'},{field:'supplier',label:'SUPPLIER'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'retDate',label:'Return Date',type:'date'},{id:'retRef',label:'Return Ref',type:'text'},
      {id:'againstRef',label:'Against Invoice No',type:'lkp',si:{screenId:'4.10.3',controlId:'1'},lt:'Select Invoice'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,
      {id:'reason',label:'Reason For Return',type:'text'},REMARKS_F,
    ],
    poFields:[
      {id:'apoDate',label:'A.P.O Date',type:'date'},{id:'mrRef',label:'M.R/L.R Ref',type:'text'},
      {id:'poRef',label:'P.O',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  // ══════════════════════════════════════════════════════════════════════
  // GRN SCREENS (4.8.14 / 4.8.15 / 4.8.16)
  // ══════════════════════════════════════════════════════════════════════

  '4.8.14': {
    sid:'4.8.14', isReturn:false, category:'grn',
    title:'GRN Against P.O',
    crumb:'Procurement › Goods Receipts & Barcode › GRN Against P.O',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRN No', prevValue:'GRN101N0005',
    listCols:[{field:'grnNo',label:'GRN NO'},{field:'grnDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'poRef',label:'AGAINST P.O'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'mrDate',label:'M.R Date',type:'date'},{id:'mrRef',label:'M.R Ref',type:'text'},
      {id:'mrTemplate',label:'M.R Template',type:'text'},{id:'piDate',label:'P.Invoice Date',type:'date'},
      PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
    poFields:[
      {id:'poDate',label:'P.O Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},
      {id:'againstPoNo',label:'Against P.O No',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  '4.8.15': {
    sid:'4.8.15', isReturn:false, category:'grn',
    title:'GRN Against P.I',
    crumb:'Procurement › Goods Receipts & Barcode › GRN Against P.I',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRN No', prevValue:'GRN101N0006',
    listCols:[{field:'grnNo',label:'GRN NO'},{field:'grnDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'piRef',label:'AGAINST P.I'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'mrDate',label:'M.R Date',type:'date'},{id:'mrRef',label:'M.R Ref',type:'text'},
      {id:'mrTemplate',label:'M.R Template',type:'text'},{id:'piDate',label:'P.Invoice Date',type:'date'},
      PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
    poFields:[
      {id:'piDate2',label:'P.I Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},
      {id:'againstPiNo',label:'Against P.I No',type:'lkp',si:{screenId:'4.10.3',controlId:'1'},lt:'Select P.I'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  '4.8.16': {
    sid:'4.8.16', isReturn:true, category:'grn-return',
    title:'GRN Return',
    crumb:'Procurement › Goods Receipts & Barcode › GRN Return',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRN Return No', prevValue:'GRR101N0004',
    listCols:[{field:'retNo',label:'RETURN NO'},{field:'retDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'againstGrn',label:'AGAINST GRN'},{field:'qty',label:'QTY'}],
    gFields:[
      {id:'retDate',label:'Return Date',type:'date'},{id:'retRef',label:'Return Ref',type:'text'},
      {id:'againstGrnNo',label:'Against GRN No',type:'lkp',si:{screenId:'4.8.1',controlId:'7'},lt:'Select GRN'},
      {id:'grnDate',label:'GRN Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,
      {id:'reason',label:'Reason For Return',type:'text'},REMARKS_F,
    ],
    poFields:[
      {id:'apoDate',label:'A.P.O Date',type:'date'},{id:'mrRef',label:'M.R/L.R Ref',type:'text'},
      {id:'poRef',label:'P.O',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},
      {id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F,
    ],
  },

  // ══════════════════════════════════════════════════════════════════════
  // GRC SCREENS (4.8.1 / 4.8.2 / 4.8.3 / 4.8.5 / 4.8.6 / 4.8.8 / 4.8.13 / 4.21.5)
  // ══════════════════════════════════════════════════════════════════════

  '4.8.1': {
    sid:'4.8.1', isReturn:false, category:'grc',
    title:'Goods Receipt Challan (Direct)',
    crumb:'Procurement › Goods Receipts & Barcode › GRC Direct',
    tab1:'General', t1k:'F3', tab2:'Additional', t2k:'F4',
    docLabel:'GRC No', prevValue:'GRC101N0010',
    listCols:[{field:'grcNo',label:'GRC NO'},{field:'grcDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'branch',label:'BRANCH'},{field:'qty',label:'QTY'}],
    gFields:[{id:'grcDate',label:'GRC Date',type:'date'},{id:'grcRef',label:'GRC Ref',type:'text'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,{id:'branch',label:'Branch',type:'text'},REMARKS_F],
    poFields:[{id:'lrRef',label:'L.R Ref',type:'text'},{id:'lrDate',label:'L.R Date',type:'date'},{id:'vehicle',label:'Vehicle No',type:'text'},REMARKS_F],
  },

  '4.8.2': {
    sid:'4.8.2', isReturn:false, category:'grc',
    title:'Goods Receipt Challan Agst PO',
    crumb:'Procurement › Goods Receipts & Barcode › GRC Against PO',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRC No', prevValue:'GRC101N0009',
    listCols:[{field:'grcNo',label:'GRC NO'},{field:'poNo',label:'PO NO'},{field:'grcDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'qty',label:'QTY'}],
    gFields:[{id:'grcDate',label:'GRC Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F],
    poFields:[{id:'poDate',label:'P.O Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},{id:'againstPoNo',label:'Against P.O No',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},{id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F],
  },

  '4.8.3': {
    sid:'4.8.3', isReturn:false, category:'grc',
    title:'Goods Receipt Challan Template',
    crumb:'Procurement › Goods Receipts & Barcode › GRC Template',
    tab1:'General', t1k:'F3', tab2:'Template', t2k:'F4',
    docLabel:'Template No', prevValue:'GRCT101N0002',
    listCols:[{field:'tplNo',label:'TEMPLATE NO'},{field:'tplName',label:'TEMPLATE NAME'},{field:'tplDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'}],
    gFields:[{id:'tplName',label:'Template Name',type:'text'},{id:'tplDate',label:'Template Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F],
    poFields:[{id:'baseGrcNo',label:'Base GRC No',type:'text'},{id:'frequency',label:'Frequency',type:'text'},REMARKS_F],
  },

  '4.8.5': {
    sid:'4.8.5', isReturn:true, category:'grc-return',
    title:'Goods Returns Challan',
    crumb:'Procurement › Goods Receipts & Barcode › Goods Returns Challan',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRC Return No', prevValue:'GRCR101N0005',
    listCols:[{field:'retNo',label:'RETURN NO'},{field:'retDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'reason',label:'REASON'},{field:'qty',label:'QTY'}],
    gFields:[{id:'retDate',label:'Return Date',type:'date'},{id:'retRef',label:'Return Ref',type:'text'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,{id:'reason',label:'Reason For Return',type:'text'},REMARKS_F],
    poFields:[{id:'apoDate',label:'A.P.O Date',type:'date'},{id:'mrRef',label:'M.R/L.R Ref',type:'text'},{id:'poRef',label:'P.O',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},{id:'invDate',label:'Invoice Date',type:'date'},REMARKS_F],
  },

  '4.8.6': {
    sid:'4.8.6', isReturn:true, category:'grc-return',
    title:'Goods Return Agst GRC',
    crumb:'Procurement › Goods Receipts & Barcode › Goods Return Against GRC',
    tab1:'General', t1k:'F3', tab2:'Against GRC', t2k:'F4',
    docLabel:'GRC Return No', prevValue:'GRCR101N0004',
    listCols:[{field:'retNo',label:'RETURN NO'},{field:'grcNo',label:'AGAINST GRC'},{field:'retDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'qty',label:'QTY'}],
    gFields:[{id:'retDate',label:'Return Date',type:'date'},{id:'againstGrcNo',label:'Against GRC No',type:'lkp',si:{screenId:'4.8.1',controlId:'7'},lt:'Select GRC'},{id:'grcDate',label:'GRC Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,{id:'reason',label:'Reason',type:'text'},REMARKS_F],
    poFields:[{id:'apoDate',label:'A.P.O Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},{id:'poRef',label:'P.O',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},REMARKS_F],
  },

  '4.8.8': {
    sid:'4.8.8', isReturn:true, category:'grc-return',
    title:'Goods Returns Packing List',
    crumb:'Procurement › Goods Receipts & Barcode › Goods Returns Packing List',
    tab1:'General', t1k:'F3', tab2:'Packing', t2k:'F4',
    docLabel:'Packing No', prevValue:'GRCPL101N0003',
    listCols:[{field:'packNo',label:'PACKING NO'},{field:'packDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'boxes',label:'BOXES'}],
    gFields:[{id:'packDate',label:'Packing Date',type:'date'},{id:'packRef',label:'Packing Ref',type:'text'},SUPPLIER_F,PURCH_AC_F,REMARKS_F],
    poFields:[{id:'packType',label:'Pack Type',type:'text'},{id:'boxes',label:'No of Boxes',type:'text'},{id:'weight',label:'Weight (kg)',type:'text'},REMARKS_F],
  },

  '4.8.13': {
    sid:'4.8.13', isReturn:false, category:'grc',
    title:'Goods Receipt Challan (Garments)',
    crumb:'Procurement › Goods Receipts & Barcode › GRC Garments',
    tab1:'General', t1k:'F3', tab2:'Against P.O', t2k:'F4',
    docLabel:'GRC No', prevValue:'GRCG101N0006',
    listCols:[{field:'grcNo',label:'GRC NO'},{field:'grcDate',label:'DATE'},{field:'garmentType',label:'GARMENT TYPE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'qty',label:'QTY'}],
    gFields:[{id:'grcDate',label:'GRC Date',type:'date'},{id:'grcRef',label:'GRC Ref',type:'text'},{id:'garmentType',label:'Garment Type',type:'text'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,{id:'branch',label:'Branch',type:'text'},REMARKS_F],
    poFields:[{id:'poDate',label:'P.O Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},{id:'againstPoNo',label:'Against P.O No',type:'lkp',si:{screenId:'4.4.2',controlId:'1'},lt:'Select PO'},{id:'season',label:'Season',type:'text'},REMARKS_F],
  },

  '4.21.5': {
    sid:'4.21.5', isReturn:false, category:'grc',
    title:'Goods Receipt Challan Agst PB',
    crumb:'Procurement › Party Bill › GRC Against Party Bill',
    tab1:'General', t1k:'F3', tab2:'Against P.B', t2k:'F4',
    docLabel:'GRC No', prevValue:'GRC101N0007',
    listCols:[{field:'grcNo',label:'GRC NO'},{field:'pbNo',label:'AGAINST PB'},{field:'grcDate',label:'DATE'},{field:'supplier',label:'SUPPLIER NAME'},{field:'qty',label:'QTY'}],
    gFields:[{id:'grcDate',label:'GRC Date',type:'date'},PAY_MODE_F,SUPPLIER_F,PURCH_AC_F,REMARKS_F],
    poFields:[{id:'pbDate',label:'P.B Date',type:'date'},{id:'lrRef',label:'L.R Ref',type:'text'},{id:'againstPbNo',label:'Against P.B No',type:'lkp',si:{screenId:'4.21.1',controlId:'1'},lt:'Select Party Bill'},{id:'pbType',label:'P.B Type',type:'text'},{id:'invDate',label:'Invoice Date',type:'date'},PAY_MODE_F,REMARKS_F],
  },
};

/** Get config for a screenId — falls back to 4.10.3 */
export function getProcConfig(sid) {
  return ALL_PROC_CONFIGS[sid] || ALL_PROC_CONFIGS['4.10.3'];
}

/** Demo rows for testing */
export const DEMO_ROWS_BY_CATEGORY = {
  'purchase-invoice': [
    {code:'1127000143', hsn:'62031990', name:'Printed Shirt',   artCode:'A0000143', oemCode:'1000', uom:'Qty', qty:'1', rate:'150.00', price:'150.00', mrp:'799.00', disc:'150', pn:'P', cgst:'2.50', sgst:'2.50', amount:'150.00', division:'Textiles', dept:'Mens', category:'Shirts', gstType:'excl'},
    {code:'1127000144', hsn:'62031990', name:'Solid Shirt',     artCode:'A0000144', oemCode:'1001', uom:'Qty', qty:'2', rate:'150.00', price:'300.00', mrp:'799.00', disc:'0',   pn:'P', cgst:'2.50', sgst:'2.50', amount:'300.00', division:'Textiles', dept:'Mens', category:'Shirts', gstType:'incl'},
  ],
  'grn': [
    {code:'1127000206', hsn:'62031990', name:'Printed Saree',   artCode:'A0000206', oemCode:'2000', uom:'Qty', qty:'1', rate:'520.00', price:'520.00', mrp:'999.00', disc:'0',   pn:'P', cgst:'2.50', sgst:'2.50', amount:'520.00', division:'Textiles', dept:'Mens', category:'Shirts', gstType:'excl'},
    {code:'1127000207', hsn:'62031990', name:'Cotton Saree',    artCode:'A0000207', oemCode:'2001', uom:'Qty', qty:'2', rate:'520.00', price:'1040.00',mrp:'999.00', disc:'60',  pn:'P', cgst:'2.50', sgst:'2.50', amount:'1040.00',division:'Textiles', dept:'Mens', category:'Shirts', gstType:'excl'},
  ],
  'grn-return': [
    {code:'1127000143', name:'Printed Shirt',  uom:'Qty', qty:'1', rate:'150.00', mrp:'799.00', disc:'0', pn:'P', cgst:'2.50', sgst:'2.50', amount:'150.00'},
  ],
  'grc': [
    {code:'GRC001', name:'Cotton Fabric Roll', uom:'Mtr', qty:'10', rate:'250.00', price:'2500.00', mrp:'499.00', disc:'0', pn:'P', cgst:'2.50', sgst:'2.50', amount:'2500.00', division:'Textiles', dept:'Womens', category:'Fabric'},
    {code:'GRC002', name:'Silk Fabric Roll',   uom:'Mtr', qty:'5',  rate:'480.00', price:'2400.00', mrp:'850.00', disc:'50', pn:'P', cgst:'2.50', sgst:'2.50', amount:'2400.00', division:'Textiles', dept:'Womens', category:'Fabric', gstType:'excl'},
  ],
  'purchase-returns': [
    {code:'PR001', name:'Returned Item', uom:'Qty', qty:'1', rate:'150.00', mrp:'799.00', disc:'0', pn:'P', cgst:'2.50', sgst:'2.50', amount:'150.00'},
  ],
};
